/** Router navigation `state` key that records which UI started the navigation. */
export const NAVIGATION_SOURCE_STATE_KEY = 'navigationSource';

export const NAVIGATION_SOURCE_ASIDE_MENU = 'aside_menu';
